import { Index, type JSX } from "solid-js";

import clsx from "~/util/html/style";

import styles from "../deck.module.css";
import type { QuestionsSlide as QuestionsSlideData } from "../types";

/** The fixed closing from Twelve's library, never written by the AI. */
export function QuestionsSlide(props: { slide: QuestionsSlideData }): JSX.Element {
  return (
    <>
      <div>
        <h2 class={clsx(styles["s-h"], styles["cl-h"])}>{props.slide.headline}</h2>
        <p class={styles["s-lead"]}>{props.slide.lead}</p>
      </div>
      <ol class={styles["next"]}>
        <Index each={props.slide.steps}>
          {(step, position) => (
            <li>
              <span class={styles["next-n"]} aria-hidden="true">
                {position + 1}
              </span>
              <span>
                {step().title}
                <span class={styles["next-d"]}>{step().detail}</span>
              </span>
            </li>
          )}
        </Index>
      </ol>
    </>
  );
}
